import React from 'react'

import { LoadingTripleSpinner } from '@frame/ui-components/loading-triple-spinner'
import { Body } from '@frame/ui-primitives/body'

import { DataAttribute } from '@frame/types'

export function Loading() {
  return (
    <Body
      data-cy={DataAttribute.SCREEN_LOADING}
      className="mx-auto flex h-full w-auto flex-1 flex-col items-center justify-center"
      paddingTopOverride={0}
    >
      <LoadingTripleSpinner />
      <p className="loading-text mt-6 w-[125px] text-moss-500">Just a moment</p>
    </Body>
  )
}
